import {Component, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {CustomerModel} from 'src/app/models/customer.model';
import {ConfigurationModel} from '../../models/configuration.model';
import {ConfigurationService} from '../../services/configuration.service';

@Component({
    selector: 'app-addcustomer',
    templateUrl: './addcustomer.page.html',
    styleUrls: ['./addcustomer.page.scss'],
})
export class AddcustomerPage implements OnInit {

    customer = new CustomerModel();
    config: ConfigurationModel;

    constructor(public modalController: ModalController,
                private configuration: ConfigurationService) {

    }

    ngOnInit() {
        this.config = this.configuration.getConfiguration();
    }

    async saveCustomer() {
        if (!this.customer.name || this.customer.name === '') {
            alert('Please inform a customer name');
        } else {
            this.customer.tender = 'STANDARD';
            this.customer.hireDisc = 0;
            this.customer.saleDisc = 0;
            this.customer.suspended = 'N';
            this.customer.depot = this.config.selectedDepot;
            await this.modalController.dismiss(this.customer);
        }
    }

}
